import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { bindActionCreators } from 'redux';

import * as actions from 'containers/App/actions';
import { ChecklistComponent } from 'components/NCCheckList/Checklist';
import './style.scss';

const ImportantTodoList = ({ tasks }) => {
  const [activeTaskIndex, setActiveTask] = useState(-1);
  const dispatch = useDispatch();
  const { createNotificationTask } = bindActionCreators(actions, dispatch);

  const createTask = () => {
    const variables = {
      module: 'loginTasks',
      focusLevel: 1,
      input: {},
      referenceId: tasks.length > 0 ? tasks[0].id : null,
    };

    if (variables) {
      createNotificationTask({ variables });
      setActiveTask(0);
    }
  };

  return (
    <div name="checklist">
      <div name="headers">
        <div name="controls">
          <button
            className="APIconButton"
            name="add"
            onClick={createTask}
          >
            +
          </button>
        </div>
        <h2
          name="name"
          className="heading-section"
        >
          Important To-Dos
        </h2>
        {!tasks?.length && (
          <div name="empty">
            Congratulations! You've completed all of your important tasks.
            Check the All My Tasks area to the left for any other items assigned to you.
          </div>
        )}
      </div>
      <ChecklistComponent
        tasks={tasks}
        module="assignedTasks"
        active={activeTaskIndex}
        setActive={setActiveTask}
      />
    </div>
  );
};

export default ImportantTodoList;
